( function( $ ){

  const $body = $( 'body' );
  const $header = $( '#site-header' );
  const $main = $( '.header-main', $header );
  const $htop = $( '#htop', $header );
  const $menu = $( '#menu-wrap', $header );
  const $toggle = $( '#mobile-menu-toggle', $header );
  const speed = 300;

  const menu_bp = $header.data( 'menu-bp' );


  function is_mobile () {
    return $toggle.is( ':visible' );
  }


  // create focus trap
  const focus_trap = focusTrap.createFocusTrap( $header.get(0), {
    onActivate () {
      $toggle.addClass( 'is-active' );
      $menu.addClass( 'visible' );
      $body.addClass( 'menu-open' );
    },
    onDeactivate () {
      $toggle.removeClass( 'is-active' );
      $body.removeClass( 'menu-open' );
      setTimeout( function () {
        $menu.removeClass( 'visible' );
      }, speed );
    },
    initialFocus: $toggle.get(0),
  });


  function resize () {
    const root = document.querySelector( ':root' );
    $header.toggleClass( 'mobile', !ThemeJS.Media_Queries.is_at_least( menu_bp ) );
    root.style.setProperty( '--header-height', `${ $header.outerHeight() }px` );
    $header.get(0).style.setProperty( '--hmain-offset', `${ $main.get(0).offsetTop }px` );
    $menu.removeClass( 'mobile-transition-enabled' );
    setTimeout( function () {
      $menu.addClass( 'mobile-transition-enabled' );
    }, 0 );
    if ( ThemeJS.Media_Queries.is_at_least( menu_bp ) ) {
      focus_trap.deactivate();
      $( 'button.sub-menu-toggle' ).closest( '.menu-item' ).each( function () {
        set_submenu_open( $(this), false );
      });
    }
  }

  const ro = new ResizeObserver( entries => resize() )
  ro.observe( $header.get(0) )

  // toggle mobile menu on hamburger click
  $toggle.click( () => {
    $body.hasClass( 'menu-open' ) ? focus_trap.deactivate() : focus_trap.activate();
  });


  // function to set submenus open/close
  function set_submenu_open ( $item, opening ) {
    let $btn = $( '> .link-wrap button.sub-menu-toggle', $item );
    if ( $btn.length ) {
      if($item.hasClass('d0-item')){
        let $current = $item.find('.current-menu-parent');
        if ( $current.length ) { 
          let uniqid = $($current).data('uniqid');
          activate_d2_slide_by_uniqid(uniqid);
        }else if ($current = $item.find('.d1-item.current-menu-item')){
          let uniqid = $($current).data('uniqid');
          activate_d2_slide_by_uniqid(uniqid);
        }
      }

      let $submenu = $( `#${ $btn.attr( 'aria-controls' ) }` );
      if ( !$submenu.length ) { return; }
      $btn.attr( 'aria-expanded', opening ? 'true' : 'false' );
      if ( !$submenu.is('[role=tabpanel]') ) {
        $submenu.attr( 'aria-hidden', opening ? 'false' : 'true' )[ opening ? 'slideDown' : 'slideUp' ]( speed );
        clearTimeout( $submenu.data( 'visTimeout' ) );
        if ( opening ) {
          $submenu.css( 'visibility', 'visible' );
        } else {
          $submenu.data( 'visTimeout', setTimeout( () => {
            $submenu.css( 'visibility', 'hidden' );
          }, speed ))
        }
      }
    } else if ( $item.hasClass('d1-item') && $item.closest('.expanded-submenu-wrap').length ) {
      activate_d2_slide_by_uniqid( $item.data('uniqid'), true )
    }
  }


  // toggle submenus on click of caret btns
  $menu.on( 'click', 'button.sub-menu-toggle', function ( e ) {
    set_submenu_open( $(this).closest( '.menu-item' ), $(this).attr( 'aria-expanded' ) == 'false' );
  });

  $menu.on( 'click', '.menu-item', function ( e ) {
    if ( !is_mobile() ) { return; }
    const $target = $(e.target);
    if ( $target.closest( 'a, button' ).length ) { return; }
    e.stopPropagation();
    const $item = $target.closest( '.menu-item' );
    if ( $item.hasClass( 'menu-item-has-children' ) ) {
      const $btn = $( 'button.sub-menu-toggle', $item );
      if ( $btn.is(':visible') ) {
        set_submenu_open( $item, $( 'button.sub-menu-toggle', $item ).attr( 'aria-expanded' ) == 'false'  );
      }
    }
  });


  // close submenu on tab out
  $menu.on( 'focusout', 'li.d0-item.menu-item-has-children', function ( e ) {
    if ( is_mobile() || $.contains( this, e.relatedTarget ) ) { return; }
    set_submenu_open( $(this), false );
  });

  // trigger hover effects via js toggling of attrs
  function desktop_only_set_open ( $item, open ) {
    if ( is_mobile() ) { return }
    set_submenu_open( $item, open )
  }
  $menu
    .on( 'mouseenter', 'li.d0-item.menu-item-has-children', function () { desktop_only_set_open( $(this), true ) } )
    .on( 'mouseleave', 'li.d0-item.menu-item-has-children', function () { desktop_only_set_open( $(this), false ) } )
    

  // expanded d2 sliders
  const d2_slider_args = {
    rows: 0,
    dots: false,
    arrows: false,
    slidesToShow: 1,
    waitForAnimate: false,
    fade: true,
    speed: 300,
    cssEase: 'ease',
  }
  function activate_d2_slide_by_uniqid ( uniqid, focus = false ) {
    const $slide = $( `div.d2-wrap div.slick-initialized div[data-uniqid=${uniqid}]` );
    if ( $slide.length ) {
      const $slider = $slide.closest( '.slick-initialized' );
      $slider.slick( 'slickGoTo', $slide.data( 'slick-index' ) );
      if ( focus ) {
        autoFocusing = true
        $( 'a', $slide ).first().focus()
        setTimeout( () => { autoFocusing = false }, 0 )
      }
      const $item = $( `.d1-item[data-uniqid="${uniqid}"]` );
      if ( $item.length ) {
        $item.addClass( 'children-active' );
      }
    }
  }
  $( function () {
    const $sliders = $( 'div.expanded-submenu-wrap div.d2-wrap div.slider', $menu )

    function set_active_d1_item ( slick, index ) {
      const $slide = $( slick.$slides[ index ] )
      const uniqid = $slide.data( 'uniqid' )
      const $d1_items = $( slick.$slider ).closest( 'div.expanded-submenu-wrap' ).find( 'div.d1-item' )
      $d1_items.removeClass( 'children-active' )
      if ( $slide.children().length ) {
        $d1_items.filter( `[data-uniqid="${uniqid}"]` ).addClass( 'children-active' )
      }
    }
    
    $sliders.on( 'init beforeChange', function( e, slick, current, next ) {
      set_active_d1_item( slick, next ?? 0 )
    })

    $sliders.each( function () {
      $(this).slick( d2_slider_args );
    });
    $menu.on( 'mouseenter', 'div.expanded-submenu-wrap div.d1-item', function () {
      activate_d2_slide_by_uniqid( $(this).data('uniqid') )
    })
  });


  // focus manipulation
  let lastInputType = null;
  let autoFocusing = false;
  document.addEventListener('keydown', e => { lastInputType = 'keyboard' })
  document.addEventListener('mousedown', e => { lastInputType = 'mouse' })
  document.addEventListener('touchstart', e => { lastInputType = 'touch' })

  $menu.on( 'focusout', '.expanded-submenu-wrap div.d2-wrap div.slick-slide', function ( e ) {
    if ( lastInputType !== 'keyboard' || !e.relatedTarget || $.contains( this, e.relatedTarget ) ) { return; }
    const uniq = $(this).data('uniqid')
    const $d1_item = $( `.d1-item[data-uniqid="${uniq}"]` )
    const isForward = ( this.compareDocumentPosition( e.relatedTarget ) === Node.DOCUMENT_POSITION_FOLLOWING )
    if ( isForward ) {
      const $next = $d1_item.next()
      if ( $next.length ) {
        e.stopPropagation()
        autoFocusing = true
        $( 'a', $next ).first().focus()
      }
    } else {
      e.stopPropagation()
      autoFocusing = true
      $( 'button.sub-menu-toggle', $d1_item ).focus()
    }
    setTimeout( () => { autoFocusing = false }, 0 )
  });

  $menu.on( 'focusout', '.expanded-submenu-wrap .d1-list', function ( e ) {
    if (
      autoFocusing
      || lastInputType !== 'keyboard'
      || !e.relatedTarget
      || $.contains( this, e.relatedTarget )
      ) {
      return
    }
    const isForward = ( this.compareDocumentPosition( e.relatedTarget ) === Node.DOCUMENT_POSITION_FOLLOWING )
    if ( isForward ) {
      const $d0_item = $(this).closest('.d0-item')
      const $next = $d0_item.next()
      if ( $next.length ) {
        $( 'a', $next ).first().focus()
      }
      set_submenu_open( $d0_item, false )
    }
  })




  // treat click of a custom link '#' menu item as clicking its submenu toggle
  $menu.on( 'click', 'a[href="#"]', function ( e ) {
    e.preventDefault();
    let $btn = $( '+ .sub-menu-toggle', this );
    if ( $btn.length ) {
      $btn.click();
    }
  });

})( jQuery );
